import './InternetSchool.less'


const  InternetSchool = () => {

  const handelClick = () => {
    const video = document.getElementById('video')
    video.play()
  }

  return (
    <div className="pg-internet-school">
      <img src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/InternetSchool/title-01.png' />
      <div className='video--wrap'>
        <video id='video' controls onClick={handelClick} poster='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/InternetSchool/video-face.png'>
          <source src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/InternetSchool/video-01.m4v'></source>
        </video>
      </div>
      <img src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/InternetSchool/title-02.png' />
      <img src='https://xfw-benefitfulwork.oss-cn-hangzhou.aliyuncs.com/InternetSchool/detail.png' />
    </div>
  )
}

export default InternetSchool